export const reviews=[
    {
        "id":1,
        "image":require("../../assets/IMG_6377.png"),
        "name":"Mamodou  Bojang",
        "desc":"Sheriff Gaye excels in web and app development, showcasing technical prowess, innovation, and organisational skills. Highly recommended professional."
    },
    {
        "id":2,
        "image":require("../../assets//eyan.png"),
        "name":"Ahmed Eyan Jeng",
        "desc":"Working with Sheriff has been a game-changer, he is an exceptional software engineer with a passion for clean architecture. Meticulous, innovative, and dedicated to crafting robust solutions. Highly recommend for complex projects"
    }
    ,
    {
        "id":3,
        "image":require("../../assets/author.jpeg"),
        "name":"John Attu",
        "desc":"Sheriff Gaye, our web developer at Nature's Specialty Foods, consistently delivers exceptional results, combining technical expertise with innovative solutions. A valuable asset to our team."
    },
]